// extracted by mini-css-extract-plugin
export default {"loaderRoot":"nPVg39","loading":"MPZzv8","content":"s5AHBe","loaderContainer":"_23pKXb"};